import { render, staticRenderFns } from "./UrunFotograflar.vue?vue&type=template&id=f96f497c&scoped=true"
import script from "./UrunFotograflar.vue?vue&type=script&lang=js"
export * from "./UrunFotograflar.vue?vue&type=script&lang=js"
import style0 from "./UrunFotograflar.vue?vue&type=style&index=0&id=f96f497c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96f497c",
  null
  
)

export default component.exports